<template>
	<div>
		<el-page-header @back="goBack" content="人格类型内容设置"></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>分类：</span>
					<span class="glay"
						>{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
					>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>名称：</span>
						<span class="glay">{{ detalisObj.name }}</span>
					</div>
					<div class="fl1">
						<span> 标识：</span>
						<span class="glay">{{ detalisObj.examId }}</span>
					</div>
				</div>

				<div class="flex-box pub-line">
					<div class="fl1">
						<span>解析：</span>
						<span class="glay">{{ detalisObj.schemeName }}</span>
					</div>
					<div class="fl1">
						<span> 题目：</span>
						<span class="glay"
							>共 <i>{{ detalisObj.questions }}</i
							>题</span
						>
					</div>
				</div>
			</div>
		</div>
		<div class="second_tops" v-loading="loading">
			<div style="min-height: 56vh">
				<div>
					<div class="public-dialog-form">
						<el-form
							ref="ruleForm"
							:model="params"
							label-width="70px"
							label-position="left"
						>
							<el-row>
								<el-tabs
									type="card"
									v-model="contentIndex"
									@tab-click="handleTabContentClick"
								>
									<el-tab-pane
										v-for="(item, index) in contentList"
										:label="item.name"
										:name="item.code"
										:key="index"
									></el-tab-pane>
								</el-tabs>
							</el-row>
							<el-row>
								<el-tabs
									type="card"
									v-model="languageCode"
									@tab-click="handleTabClick('question')"
								>
									<el-tab-pane
										v-for="(item, index) in languageList"
										:label="item.name"
										:name="item.code"
										:key="index"
									></el-tab-pane>
								</el-tabs>
							</el-row>

							<div v-if="contentIndex == 'DOWNLOAD'">
								<el-row>
									<el-col :span="22">
										<el-form-item label="标题" prop="title">
											<el-input
												placeholder="标题"
												v-model="content.content0.title"
											></el-input>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="22">
										<el-form-item label="内容" prop="descr">
											<el-input
												placeholder="内容"
												v-model="content.content0.descr"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="22">
										<el-form-item label="标题1" prop="title">
											<el-input
												placeholder="标题"
												v-model="content.content1.title"
											></el-input>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容1.1" prop="descr">
											<el-input
												placeholder="内容1.1"
												v-model="content.content1.descr1"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件1.1">
											<upLoadImg
												:keyWord="'upload1'"
												:params="content.content1"
												@getUrl="(e) => (content.content1.upload1 = e)"
											></upLoadImg>
											<!-- <uploadCommonImg /> -->
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容1.2" prop="descr">
											<el-input
												placeholder="内容1.2"
												v-model="content.content1.descr2"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件1.2">
											<upLoadImg
												:keyWord="'upload2'"
												:params="content.content1"
												@getUrl="(e) => (content.content1.upload2 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容1.3" prop="descr">
											<el-input
												placeholder="内容1.3"
												v-model="content.content1.descr3"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件1.3">
											<upLoadImg
												:keyWord="'upload3'"
												:params="content.content1"
												@getUrl="(e) => (content.content1.upload3 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容1.4" prop="descr">
											<el-input
												placeholder="内容1.4"
												v-model="content.content1.descr4"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件1.4">
											<upLoadImg
												:keyWord="'upload4'"
												:params="content.content1"
												@getUrl="(e) => (content.content1.upload4 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容1.5" prop="descr">
											<el-input
												placeholder="内容1.5"
												v-model="content.content1.descr5"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件1.5">
											<upLoadImg
												:keyWord="'upload5'"
												:params="content.content1"
												@getUrl="(e) => (content.content1.upload5 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="22">
										<el-form-item label="标题2" prop="title">
											<el-input
												placeholder="标题"
												v-model="content.content2.title"
											></el-input>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容2.1" prop="descr">
											<el-input
												placeholder="内容2.1"
												v-model="content.content2.descr1"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件2.1">
											<upLoadImg
												:keyWord="'upload1'"
												:params="content.content2"
												@getUrl="(e) => (content.content2.upload1 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容2.2" prop="descr">
											<el-input
												placeholder="内容2.2"
												v-model="content.content2.descr2"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件2.2">
											<upLoadImg
												:keyWord="'upload2'"
												:params="content.content2"
												@getUrl="(e) => (content.content2.upload2 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容2.3" prop="descr">
											<el-input
												placeholder="内容2.3"
												v-model="content.content2.descr3"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件2.3">
											<upLoadImg
												:keyWord="'upload3'"
												:params="content.content2"
												@getUrl="(e) => (content.content2.upload3 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容2.4" prop="descr">
											<el-input
												placeholder="内容2.4"
												v-model="content.content2.descr4"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件2.4">
											<upLoadImg
												:keyWord="'upload4'"
												:params="content.content2"
												@getUrl="(e) => (content.content2.upload4 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容2.5" prop="descr">
											<el-input
												placeholder="内容2.5"
												v-model="content.content2.descr5"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件2.5">
											<upLoadImg
												:keyWord="'upload5'"
												:params="content.content2"
												@getUrl="(e) => (content.content2.upload5 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="22">
										<el-form-item label="标题3" prop="title">
											<el-input
												placeholder="标题"
												v-model="content.content3.title"
											></el-input>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容3.1" prop="descr">
											<el-input
												placeholder="内容3.1"
												v-model="content.content3.descr1"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件3.1">
											<upLoadImg
												:keyWord="'upload1'"
												:params="content.content3"
												@getUrl="(e) => (content.content3.upload1 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容3.2" prop="descr">
											<el-input
												placeholder="内容3.2"
												v-model="content.content3.descr2"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件3.2">
											<upLoadImg
												:keyWord="'upload2'"
												:params="content.content3"
												@getUrl="(e) => (content.content3.upload2 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容3.3" prop="descr">
											<el-input
												placeholder="内容3.3"
												v-model="content.content3.descr3"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件3.3">
											<upLoadImg
												:keyWord="'upload3'"
												:params="content.content3"
												@getUrl="(e) => (content.content3.upload3 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容3.4" prop="descr">
											<el-input
												placeholder="内容3.4"
												v-model="content.content3.descr4"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件3.4">
											<upLoadImg
												:keyWord="'upload4'"
												:params="content.content3"
												@getUrl="(e) => (content.content3.upload4 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容3.5" prop="descr">
											<el-input
												placeholder="内容3.5"
												v-model="content.content3.descr5"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件3.5">
											<upLoadImg
												:keyWord="'upload5'"
												:params="content.content3"
												@getUrl="(e) => (content.content3.upload5 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容3.6" prop="descr">
											<el-input
												placeholder="内容3.6"
												v-model="content.content3.descr6"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件3.6">
											<upLoadImg
												:keyWord="'upload6'"
												:params="content.content3"
												@getUrl="(e) => (content.content3.upload6 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容3.7" prop="descr">
											<el-input
												placeholder="内容3.7"
												v-model="content.content3.descr7"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件3.7">
											<upLoadImg
												:keyWord="'upload7'"
												:params="content.content3"
												@getUrl="(e) => (content.content3.upload7 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="22">
										<el-form-item label="标题4" prop="title">
											<el-input
												placeholder="标题"
												v-model="content.content4.title"
											></el-input>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容4.1" prop="descr">
											<el-input
												placeholder="内容4.1"
												v-model="content.content4.descr1"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件4.1">
											<upLoadImg
												:keyWord="'upload1'"
												:params="content.content4"
												@getUrl="(e) => (content.content4.upload1 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容4.2" prop="descr">
											<el-input
												placeholder="内容4.2"
												v-model="content.content4.descr2"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件4.2">
											<upLoadImg
												:keyWord="'upload2'"
												:params="content.content4"
												@getUrl="(e) => (content.content4.upload2 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="22">
										<el-form-item label="标题5" prop="title">
											<el-input
												placeholder="标题"
												v-model="content.content5.title"
											></el-input>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="18">
										<el-form-item label="内容5.1" prop="descr">
											<el-input
												placeholder="内容5.1"
												v-model="content.content5.descr1"
												type="textarea"
												:rows="6"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4" style="margin-left: 12px">
										<el-form-item label="文件5.1">
											<upLoadImg
												:keyWord="'upload1'"
												:params="content.content5"
												@getUrl="(e) => (content.content5.upload1 = e)"
											></upLoadImg>
										</el-form-item>
									</el-col>
								</el-row>
							</div>

							<div v-if="contentIndex == 'FIXED'">
								<strong>总览</strong>
								<template v-for="(item, index) in FIXEDMode.zonglan">
									<el-form-item
										:key="item.name + 'zonglan'"
										:label="FIXEDMode.zonglan[index].label"
										:prop="FIXEDMode.zonglan[index].name"
									>
										<component
											:is="FIXEDMode.zonglan[index].el"
											v-model="
												params.content.zonglan[FIXEDMode.zonglan[index].name]
											"
											v-bind="FIXEDMode.zonglan[index].attrs"
											:params="
												params.content.zonglan ? params.content.zonglan : ''
											"
										/>
									</el-form-item>
								</template>
								<strong>梦的解析与启示</strong>
								<template v-for="(item, index) in FIXEDMode.qishi">
									<el-form-item
										:key="item.name + 'qishi'"
										:label="FIXEDMode.qishi[index].label"
										:prop="FIXEDMode.qishi[index].name"
									>
										<component
											:is="FIXEDMode.qishi[index].el"
											v-model="
												params.content.qishi[FIXEDMode.qishi[index].name]
											"
											v-bind="FIXEDMode.qishi[index].attrs"
											:params="params.content.qishi ? params.content.qishi : ''"
										/>
									</el-form-item>
								</template>
								<strong>探索神秘力量</strong>
								<template v-for="(item, index) in FIXEDMode.liliang">
									<el-form-item
										:key="item.name + 'liliang'"
										:label="FIXEDMode.liliang[index].label"
										:prop="FIXEDMode.liliang[index].name"
									>
										<component
											:is="FIXEDMode.liliang[index].el"
											v-model="
												params.content.liliang[FIXEDMode.liliang[index].name]
											"
											v-bind="FIXEDMode.liliang[index].attrs"
											:params="
												params.content.liliang ? params.content.liliang : ''
											"
										/>
									</el-form-item>
								</template>
							</div>
						</el-form>
						<span slot="footer" class="public-dialog-footer">
							<el-button size="medium" @click="handleContentEdit('reset')">
								重 置</el-button
							>
							<el-button
								size="medium"
								type="primary"
								@click="handleContentEdit('add')"
								>提 交</el-button
							>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import upLoadImg from "@views/international/components/upLoadImg";
import uploadCommonImg from "@comp/uploadCommonImg";
import { emptyShow, isEmpty } from "@utils/tools";
import richText from "@comp/richText";
import { FIXED } from "./mjywlRgCtSet.js";
import { ossUpload } from "@utils/filters/upload";

export default {
	name: "mjywlList",
	components: {
		richText,
		upLoadImg,
		uploadCommonImg,
	},
	data() {
		return {
			emptyShow,
			isEmpty,
			detalisObj: {},
			loading: false,
			initJZData: {},
			activeName: "",
			params: {},
			flag: false,
			innerVisible: false,
			srcList: [],
			isMoer: true,
			languageCode: "",
			languageList: [],
			contentList: [
				{
					name: "下载内容设置",
					code: "DOWNLOAD",
				},
				{
					name: "固定内容设置",
					code: "FIXED",
				},
			],
			FIXEDMode: FIXED(),
			contentIndex: "DOWNLOAD",
			content: {
				upload1: "",
				content0: {
					title: "",
					descr: "",
				},
				content1: {
					title: "",
					descr1: "",
					upload1: "",
					descr2: "",
					upload2: "",
					descr3: "",
					upload3: "",
					descr4: "",
					upload4: "",
					descr5: "",
					upload5: "",
				},
				content2: {
					title: "",
					descr1: "",
					upload1: "",
					descr2: "",
					upload2: "",
					descr3: "",
					upload3: "",
					descr4: "",
					upload4: "",
					descr5: "",
					upload5: "",
				},
				content3: {
					title: "",
					descr1: "",
					upload1: "",
					descr2: "",
					upload2: "",
					descr3: "",
					upload3: "",
					descr4: "",
					upload4: "",
					descr5: "",
					upload5: "",
					descr6: "",
					upload6: "",
					descr7: "",
					upload7: "",
				},
				content4: {
					title: "",
					descr1: "",
					upload1: "",
					descr2: "",
				},
				content5: {
					title: "",
					descr1: "",
					upload1: "",
				},
			},
		};
	},
	watch: {},
	mounted() {
		this.getAppraisalData();
		this.getLanguageList();
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		handleTabClick() {
			this.initJZ();
		},
		handleTabContentClick(e) {
			this.contentIndex = e.name;
			this.initJZ(e.name);
		},
		/**
		 * 初始化基准
		 */
		async initJZ(e) {
			this.loading = true;
			this.params.examInfoId = this.detalisObj.examInfoId;
			this.params.code = e || this.contentIndex;
			const params = {
				...this.params,
			};
			delete params.content;
			const { data: resData } = await this.$get(`exam/result/extension/get`, {
				params,
				headers: {
					"Language-Code": this.languageCode,
				},
			});
			if (resData.result != 200) {
				this.loading = false;
				return;
			}
			if (resData.data) {
				this.loading = false;
				this.params = {
					...resData.data,
				};
				this.params.content = JSON.parse(resData.data.content);

				this.content = JSON.parse(resData.data.content);
				this.innerVisible = true;
			} else {
				this.params = {};
				this.innerVisible = true;
				this.loading = false;
			}
		},
		handleContentEdit(type) {
			if (type == "add") {
				this.$refs.ruleForm.validate((valid) => {
					if (!valid) return;
					this.$confirm("确认保存数据, 是否继续?", "提示", {
						type: "info",
					}).then(async () => {
						const data = { ...this.params };
						if (data.code == "FIXED") {
							data.content = JSON.stringify(data.content);
						} else {
							data.content = JSON.stringify(this.content);
						}

						console.log(data);
						const { data: resData } = await this.$post(
							"exam/result/extension/save",
							data,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.$message.success("提交成功!");
					});
				});
			} else if (type == "reset") {
				this.$confirm("确认重置当前数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					this.initJZ();
					this.$message.success("重置成功!");
				});
			}
		},
		/**
		 * 获取测评详情
		 */
		async getAppraisalData() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.detalisObj = resData.data;

			this.initJZ();
		},
		/**
		 * 返回
		 */
		goBack() {
			this.$router.back();
		},
	},
};
</script>

<style scoped lang="scss">
.appraisal-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.marr {
	margin-top: 20px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}
.second_tops {
	padding-top: 20px;
	box-sizing: border-box;
}
.public-dialog-form {
	height: 55vh;
	overflow-y: scroll;
}
</style>
<style>
.second_tops .el-tabs__item {
	white-space: pre-wrap;
	text-align: left !important;
	line-height: 46px;
	max-width: 300px;
	height: 46px !important;
}
</style>
